import axios from "axios";

export default async function SendLog() {
}
